var _g, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoManual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 130,
    viewBox: "0 0 500 130",
    role: "img",
    "aria-label": "Manual",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    transform: "translate(6 17) scale(1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.057,53.97H9.709A4.714,4.714,0,0,1,5,49.262V15.274a4.714,4.714,0,0,1,4.709-4.709H51.057a4.714,4.714,0,0,1,4.709,4.709V49.262A4.714,4.714,0,0,1,51.057,53.97ZM9.709,12.565A2.712,2.712,0,0,0,7,15.274V49.262a2.711,2.711,0,0,0,2.709,2.708H51.057a2.711,2.711,0,0,0,2.709-2.708V15.274a2.712,2.712,0,0,0-2.709-2.709Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    x: 15.278,
    y: 29.92
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    x: 27.234,
    y: 29.92
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    x: 39.189,
    y: 29.92
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    x: 15.278,
    y: 39.485
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    x: 27.234,
    y: 39.485
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 4.782,
    x: 39.189,
    y: 39.485
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.822,
    height: 2,
    x: 6.279,
    y: 20.552
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.816,15.1a1,1,0,0,1-1-1V7a1,1,0,1,1,2,0v7.1A1,1,0,0,1,17.816,15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.972,15.1a1,1,0,0,1-1-1V7a1,1,0,0,1,2,0v7.1A1,1,0,0,1,43.972,15.1Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 82,
    fill: "#333",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 54,
    fontWeight: 500
  }, "Manual")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoManual);
export default __webpack_public_path__ + "static/media/logo_manual.ac0c655a99879826c31136e84ae36e47.svg";
export { ForwardRef as ReactComponent };